/*
 * Confidential and Proprietary.
 * Do not distribute without 1-800-Flowers.com, Inc. consent.
 * Copyright 1-800-Flowers.com, Inc. 2019. All rights reserved.
 */

import React from 'react';
import PropTypes from 'prop-types';

const DesktopGiftMessage = (props) => {
   const { ROSSItemList, isAccountMMOEnabled } = props;
      
   return (
      ROSSItemList.length > 0 &&
         <>
            <h2 className="gray-color">
               <div className="split align-center">
                  <div className="align-left">Gift Message</div>

               </div>
            </h2>
            <div className={ROSSItemList[0]?.cardMsgEnable === 'true' && isAccountMMOEnabled ? 'margin-bottom min-height-100' : 'margin-bottom'}>
               <div className="desktop-gift-message-container">{ROSSItemList[0]?.cardMessage || 'No Card Message'}</div>
            </div>
         </>
   )
};

DesktopGiftMessage.defaultProps = {
   isAccountMMOEnabled: false,
   ROSSItemList: [],
};

DesktopGiftMessage.propTypes = {
   isAccountMMOEnabled: PropTypes.bool,
   ROSSItemList: PropTypes.array,
};

export default DesktopGiftMessage;
